export const isEmail = (email: string) => {
  return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);
};

export const isPhoneNumber = (phone: string) => {
  return /^(\+\d\d)? ?([\d] ?){10}$/.test(phone);
};

export const isGSTIN = (gstin: string) => {
  // 27BLFPR3550P1ZH
  return /^(\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[A-Z]{1}[\dA-Z]{1})$/.test(
    gstin.toUpperCase(),
  );
};
